import { createSlice } from "@reduxjs/toolkit";



const INITIAL_STARTE: string = "";

export function deviceUId(state = INITIAL_STARTE, action: { type: string; uid: string; }){
    if(action.type === 'UPDATE_UID'){
        console.log('uid received')
        console.log(action.uid)
        state = action.uid
    }
    return state;
}

const restoreUid = ():string => {
    const uid = window.localStorage.getItem("DEVICE_UUID");
    return uid ? JSON.parse(uid) : INITIAL_STARTE;
}

export const deviceUidSlice = createSlice({
    name: "deviceUid",
    initialState:{
        uid: restoreUid(),
    },
    reducers:{
        handleDeviceUid: (state, action) => {
            state.uid =  action.payload;
            window.localStorage.setItem("DEVICE_UUID", JSON.stringify(action.payload));
        }
    }
})
export const{
    handleDeviceUid
} = deviceUidSlice.actions;

export default deviceUidSlice.reducer;